import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getReproductionById, updateReproduction } from "../../../api/reproductionApi";
import { getAnimals } from "../../../api/animalsApi";
import { getStatus } from "../../../api/statusApi";
import './editRepro.css'

const EditReproduction = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [animalId, setAnimalId] = useState("");
    const [dateVel, setDateVel] = useState("");
    const [dateSai, setDateSai] = useState("");
    const [dateGes, setDateGes] = useState("");
    const [description, setDescription] = useState("");
    const [statusId, setStatusId] = useState("");

    const [animals, setAnimals] = useState([]);
    const [statuses, setStatuses] = useState([]);

    useEffect(() => {
        loadReproduction();
        loadAnimals();
        loadStatus();
    }, []);

    const loadReproduction = async () => {
        try {
            const r = await getReproductionById(id);

            setAnimalId(r.animal_id);
            setDateVel(r.date_velage);
            setDateSai(r.date_saille);
            setDateGes(r.date_gestation);
            setDescription(r.description);
            setStatusId(r.status_id);

        } catch (error) {
            console.error("Erreur load reproduction", error);
        }
    };

    const loadAnimals = async () => {
        try {
            const res = await getAnimals();
            setAnimals(res);
        } catch (error) {
            console.error("Erreur load animaux", error);
        }
    };

    const loadStatus = async () => {
        try {
            const res = await getStatus();
            setStatuses(res);
        } catch (error) {
            console.error("Erreur load status", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await updateReproduction(id, {
                animal_id: animalId,
                date_velage: dateVel || '',
                date_saille: dateSai || '',
                description,
                status_id: statusId,
            });
            console.log("Update successful:", res);

            navigate("/admin/reproduction");
        } catch (error) {
            console.error("Erreur update", error);
        }
    };

    return (
        <div className="container-edit-repro">
            <h2 className="h2-edit-repro">Modifier Reproduction</h2>

            <form onSubmit={handleSubmit} className="form-edit-repro">

                <div>
                    <label>Animal :</label>
                    <select value={animalId} onChange={(e) => setAnimalId(e.target.value)}>
                        <option value="">-- choisir --</option>
                        {animals.map((a) => (
                            <option key={a.id} value={a.id}>
                                {a.nom} (#{a.numero})
                            </option>
                        ))}
                    </select>
                </div>

                <div>
                    <label>Date vêlage :</label>
                    <input
                        type="date"
                        value={dateVel}
                        onChange={(e) => setDateVel(e.target.value)}
                    />
                </div>
                <div>
                    <label>Date Saillie :</label>
                    <input
                        type="date"
                        value={dateSai}
                        onChange={(e) => {setDateSai(e.target.value)}}
                    />
                </div>

                <div>
                    <label>Date Gestation :</label>
                    <input
                        type="date"
                        value={dateGes}
                        onChange={(e) => {setDateGes(e.target.value)}}
                    />
                </div>

                <div>
                    <label>Description :</label>
                    <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    ></textarea>
                </div>

                <div>
                    <label>Status :</label>
                    <select value={statusId} onChange={(e) => setStatusId(e.target.value)}>
                        <option value="">-- choisir --</option>
                        {statuses.map((s) => (
                            <option key={s.id} value={s.id}>
                                {s.titre}
                            </option>
                        ))}
                    </select>
                </div>

                <button type="submit">Modifier</button>
            </form>
        </div>
    );
};

export default EditReproduction;
